export default "__VITE_ASSET___JBiBFYa__"